<template>
  <div id="secondPart">
    <div class="mainBox">
      <div class="titlePart">
        <h2 class="title">杭甬线高速铁路</h2>
        <div class="intro">
            杭甬高速铁路是一条连接浙江省杭州市和浙江省宁波市的高速铁路，全长150千米，下辖绍兴北站、绍兴东站、余姚北站、庄桥站、宁波站等。
        </div>
      </div>
      <div class="casebutlist">
        <div class="caseButton wow animate__zoomIn" v-for="(item, index) in list" :key="index">
          {{ item }}
        </div>
      </div>
    </div>
    <div class="imgBox">
        <el-image  class="secondImg" :src="srcArr[0]" :preview-src-list="srcArr"></el-image>
        <div class="numRow">
            <div class="numItem">
                <div class="numTxt">5</div>
                <div class="plus">+</div>
                <div class="typeWord">站点</div>
            </div>
            <div class="numItem">
                <div class="numTxt">5000</div>
                <div class="plus">+</div>
                <div class="typeWord">整体站房及驻站单位</div>
            </div>
            <div class="numItem">
                <div class="numTxt">300</div>
                <div class="plus">+</div>
                <div class="typeWord">视频</div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";
export default {
  data() {
    return {
      list: ["火灾自动报警", "电气火灾系统", "水系统", "视频系统", "EPS监测"],
      srcArr:[
          require('../../assets/img/case/daping.png'),
          require('../../assets/img/case/1.jpg'),
      ]
    };
  },
  computed: {},
  created() {},
  mounted() {
      new WOW({ live: false}).init();
  },
  watch: {},
};
</script>
<style lang='scss'  scoped>
#secondPart {
  .mainBox {
    padding: 5% 0;
    background-image: url("../../assets/img/case/backg.png");
    background-position: center;
    background-size: 100% 100%;
    position: relative;
    height: 70rem;
    .titlePart {
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      margin-bottom: 3rem;
      .title {
        font-size: 2.6rem;
        line-height: 4.2rem;
        color: #ffffff;
        margin-bottom: 1rem;
      }
      .intro {
        width: 45%;
        color: #ffffff;
        font-size: 1.4rem;
        line-height: 2.2rem;
        text-align: justify;
       text-justify: inter-ideograph;/*IE*/
      }
    }
    .casebutlist {
      display: flex;
      justify-content: space-evenly;
      flex-direction: row;
      flex-wrap: wrap;
      margin: 5rem 0;
      width: 50%;
      margin-left: 25%;
      .caseButton {
        background: #ffffff;
        color: #00a087;
        padding: 0.5rem 3rem;
        border-radius: 24px;
        font-size: 1.4rem;
        font-weight: bold;
        letter-spacing: 0.15rem;
        margin: 1rem;
        box-shadow: 0px 5px 32px 0px rgba(202, 202, 202, 0.34);
        cursor: pointer;
      }
    }
  }
  .imgBox {
    width: 50%;
    height: 50rem;
    margin-left: 25%;
    position: relative;
    margin-top: -30rem;
    .secondImg {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      cursor: pointer;
    }
    .numRow {
        position: absolute;
        bottom: 3rem;
        left: 10.5rem;
        width: calc(100% - 21rem);
        display: flex;
        justify-content: space-evenly;
        color: #fff;
        height: 4.2rem;
        background: rgba(0, 0, 0, 0.5);
        .numItem{
            display: flex;
            align-items: center;
            .numTxt{
                font-size: 3rem;
                font-weight: bold;
            }
            .plus{
                font-weight: bold;
                font-size: 2.6rem;
                margin-left: 0.5rem;
                margin-top: 1rem;
            }
            .typeWord{
                font-size: 1.4rem;
                margin-left: 1.4rem;
                margin-top: 1rem;
            }
        }
    }
  }


}
@import '../../assets/responsive/case.scss'
</style>